<template>
  <v-dialog
    v-model="value"
    :max-width="maxWidth"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    overlay-opacity="0.8"
    scrollable
    @keydown.esc="$emit('close')"
    persistent
  >
    <v-card>
      <v-toolbar flat>
        <h2 v-if="title">{{ title }}</h2>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('close')">
          <v-icon size="24">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <slot name="content"></slot>
      </v-card-text>
      <v-card-actions class="px-6 pb-6">
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "base-dialog",

  props: {
    value: Boolean,
    title: String,
    maxWidth: {
      type: Number,
      default: 500,
    },
  },
};
</script>
